import {z} from 'zod';
import {OperacionControlOperativoDetalleFields, OperacionControlOperativoFields} from './fields';
import {EntityWithIdFields, schemaEntityWithId} from "../../../../../types";
import {FilePutFields} from "../../../api/file-fields";

export const schemaOperacionControlOperativo = z.object({
  [OperacionControlOperativoFields.CodPais]: z.number(),
  [OperacionControlOperativoFields.CodOperacionControlOperativoEstado]: z.number(),
  [OperacionControlOperativoFields.FechaCarga]: z.coerce.date(),
  [OperacionControlOperativoFields.Responsable]: z.string().optional(),
  [OperacionControlOperativoFields.Observaciones]: z.string().optional().nullable(),
  [OperacionControlOperativoFields.FechaAlta]: z.coerce.date().nullable(),
  [OperacionControlOperativoFields.IdUsuarioAlta]: z.number().nullable(),
  [OperacionControlOperativoFields.FechaUltMod]: z.coerce.date().nullable(),
  [OperacionControlOperativoFields.IdUsuarioUltMod]: z.number().nullable(),
  [OperacionControlOperativoFields.NombreUsuarioAlta]: z.string(),
  [OperacionControlOperativoFields.ApellidoUsuarioAlta]: z.string(),
  [OperacionControlOperativoFields.MailUsuarioAlta]: z.string(),
  [OperacionControlOperativoFields.EstadoFinalizado]: z.boolean(),
  [OperacionControlOperativoFields.Envio]: z.boolean(),
  [OperacionControlOperativoFields.IdMensaje]: z.number().nullable(),
  [OperacionControlOperativoFields.PermiteEditarOperacion]: z.boolean(),
  [OperacionControlOperativoFields.PermiteEliminarOperacion]: z.boolean(),
}).merge(schemaEntityWithId);

export type OperacionControlOperativo = z.infer<typeof schemaOperacionControlOperativo>;

export const schemaOperacionControlOperativoDetalle = z.object({
  [OperacionControlOperativoDetalleFields.IdOperacionControlOperativo]: z.number(),
  [OperacionControlOperativoDetalleFields.Sociedad]: z.string(),
  [OperacionControlOperativoDetalleFields.Control]: z.string(),
  [OperacionControlOperativoDetalleFields.Descripcion]: z.string().optional().nullable(),
  [OperacionControlOperativoDetalleFields.Conclusion]: z.string().optional().nullable(),
  [OperacionControlOperativoDetalleFields.FechaAlta]: z.coerce.date().optional().nullable(),
  [OperacionControlOperativoDetalleFields.IdUsuarioAlta]: z.number().optional().nullable(),
  [OperacionControlOperativoDetalleFields.FechaUltMod]: z.coerce.date().optional().nullable(),
  [OperacionControlOperativoDetalleFields.IdUsuarioUltMod]: z.number().optional().nullable(),
  [OperacionControlOperativoDetalleFields.Activo]: z.boolean().optional().nullable(),
  [OperacionControlOperativoDetalleFields.PermiteEditar]: z.boolean().optional().nullable(),
}).merge(schemaEntityWithId);

export type OperacionControlOperativoDetalle = z.infer<typeof schemaOperacionControlOperativoDetalle>;

export const schemaFormOperacionControlOperativoDetalle = schemaOperacionControlOperativoDetalle.pick({
  [OperacionControlOperativoDetalleFields.Sociedad]: true,
  [OperacionControlOperativoDetalleFields.Control]: true,
  [OperacionControlOperativoDetalleFields.Descripcion]: true,
  [OperacionControlOperativoDetalleFields.Conclusion]: true,
  [EntityWithIdFields.Id]: true,
});

export type FormOperacionControlOperativoDetalle = z.infer<typeof schemaFormOperacionControlOperativoDetalle>;

export const schemaFormOperacionControlOperativo = schemaOperacionControlOperativo.pick({
  [OperacionControlOperativoFields.CodPais]: true,
  [OperacionControlOperativoFields.Responsable]: true,
  [OperacionControlOperativoFields.FechaCarga]: true,
  [OperacionControlOperativoFields.Detalle]: true,
  [OperacionControlOperativoFields.Observaciones]: true,
}).extend({
    [FilePutFields.File]: z.array(z.instanceof(File)),
});

export type FormOperacionControlOperativo = z.infer<typeof schemaFormOperacionControlOperativo>;